"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkUrl = getLinkUrl;
exports.hasAnyLink = hasAnyLink;

/*
* Squidex Headless CMS
*
* @license
* Copyright (c) Squidex UG (haftungsbeschränkt). All rights reserved.
*/
function getLinkUrl(links) {
  if (!links) {
    return false;
  }

  for (var _len = arguments.length, rels = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rels[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _rels = rels; _i < _rels.length; _i++) {
    var rel = _rels[_i];
    var link = links[rel];

    if (link && link.method && link.href) {
      return link.href;
    }
  }

  return undefined;
}

function hasAnyLink(links) {
  for (var _len2 = arguments.length, rels = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rels[_key2 - 1] = arguments[_key2];
  }

  return !!getLinkUrl.apply(void 0, [links].concat(rels));
}